import React, { useState, useEffect } from 'react'
import MainTable from '../../../components/Util/MainTable'
import useParams from '../../../hook/useParams'
import { fetchCampaignByType } from '../../../apis/campaign'

function CampHistory(props) {
    const { ln_t, userInfo, setIsLoading, subTab, colTitle } = props
    const { nowEnterprise, lang } = userInfo || {}
    const { enterprise } = nowEnterprise || {}

    const params = useParams({ maxResult: 1000 }, false)
    const { fetchParams, setList, setReady, ready } = params

    const defaultCols = [
        {
            title: ln_t('campaign.product'),
            dataIndex: 'product',
            fixed: 'left',
            render: (product, data) => data?.description || product
        },
    ]    

    const [columns, setColumns] = useState([])

    const apiFunc = async () => fetchCampaignByType(enterprise, subTab, fetchParams)

    const getCustomList = async (loading = true) => {
        loading && setIsLoading(true)
        const result = await apiFunc()
        if (result?.status === 200) {
            const { results } = result.data || {}
            const { products } = results[0]

            const n = products.map(product => {
                const { id, product_id, product_description } = product
                const arr = results.map(camp => {
                    const { campaignId, products: pros } = camp
                    const campMatchProduct = pros.find(pro => pro.product_id === product_id) || {}

                    return { [campaignId]: `${campMatchProduct.referralRate || 0}%` }
                })
                const obj = Object.assign({}, ...arr)
                return {
                    productId: id,
                    product: product_id,
                    description: product_description,
                    ...obj
                }
            })

            const c = results.map(res => ({
                title: colTitle(res),
                dataIndex: res.campaignId
            }))
            setColumns([...defaultCols, ...c])
            setList(n)
        }
        loading && setIsLoading(false)
    }

    useEffect(() => {
        setReady(true)
    }, [])

    useEffect(() => {
        ready && getCustomList(false)
    }, [lang])
    
    return (
        <MainTable 
            {...props}
            className="campaign-history"
            tableName="campHistory"
            columns={columns}
            rowKey="product"
            apiFunc={apiFunc}
            params={params}
            getCustomList={getCustomList}
            noFooter
            noPage
        />
    )
}

export default CampHistory
